import React, { Component } from "react"
import "./App.css"
import CustomPlot from "./CustomPlot"
import axios from "axios"
import moment from 'moment'
import testData from "./testData"
import {LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer} from "recharts"


// this dictionary contains the cisible name and the respective keyof the select box
// the key will be used in the query string of the api
const timeranges = [ 
  { name: "Ultima Settimana", range: "lastWeek" }, 
  { name: "Ultimo Mese", range: "lastMonth" }, 
  { name: "Ultimo Anno", range: "lastYear" }, 
  { name: "Ultimo Giorno", range: "lastDay" }, 
]

const deviceId = ["PowerPV", "VS1", "IS1", "VS2", "IS2", "PercentBattery", "PowerBatt", "VBatt", "IBatt", "PowerGrid", "Vac", "Iac", "InvAlarm", "PVAlarm", "BattAlarm", "PercentGreen", "PercentViolet", "PowerHouse", "InvFlag", "global-temp","global-temp-set", "global-humidity","global-thumidity-set", "underground-temp","underground-humidity","ground-floor-temp","ground-floor-humidity", "external-temp", "external-humidity", "visibility", "clouds-coverage", "wind-speed", "season", "sunrise", "sunset"]

const monthsName = ["Gen","Feb","Mar","Apr","Mag","Giu","Lug","Ago","Set","Ott","Nov","Dic"]

const weekDaysNames = ["Lun","Mar","Mer","Gio","Ven","Sab","Dom"]

const houseDataInstance = axios.create({
  baseURL: "https://ld1urwjqxg.execute-api.eu-central-1.amazonaws.com/dev", // TODO change with the api gatewai url
  // baseURL: "http://localhost:3000", // TODO change with the api gatewai url
  timeout: 1000,
});

function getSeason(today) { // this is a deprecated function the season is now taken
  let month = today.getMonth();
  switch(month) {
    case  12:
    case  1:
    case  2:
    case  9:
    case  10:
    case  11:
      return 'winter';
    case 3:
    case 4:
    case 5:
    case 6:
    case 7:
    case 8:
      return 'summer';
    }
}

function isDayOrNight(today, sunrise, sunset) {
  if (sunrise && sunset) {
    const nowTS = today.getTime() / 1000
    if (nowTS > sunrise && nowTS < sunset) return 'day'
    else return 'night'
  } else {
    const hour = today.getHours()
    if (hour >= 7 && hour <= 19) return 'day' 
    else return 'night' 
  }
}

class App extends Component {
  constructor () {
    super()

    this.state = {
      newData: {},
      historicalData: [],
      curRange: 0, // first element of the time range array is used as default
      testSeason: 'winter' // used only for test purpose
    }
  }

  getHistoricalData = async (timeRange) => {
    const response = await houseDataInstance(`/data?range=${timeRange}&things=${JSON.stringify(deviceId)}`)
    response.data.map(el => {
      Object.keys(el).forEach(k => {
        if(!(k === 'timestamp' || el[k] === 'N/A')) {
          try {
            el[k] = parseFloat(el[k].toFixed(2))
          } catch (e) {
            console.log(e)
          }
        }
      })
    })
    return this.formatDataRange(response.data, timeRange)
  }

  getNewData = async () => {
    const response = await houseDataInstance(`/lastdata?things=${JSON.stringify(deviceId)}`)
    return response.data
  }

  onSelectChange = async (evt) => {
    const selectedRange = evt.target.value


    const response = await this.getHistoricalData(timeranges[selectedRange].range)

    this.setState({ curRange: selectedRange, historicalData: response})
  }

  formatDataRange(data, range) {
    if (range === "lastYear") {
      return data.map((x) => {
        const _ts = new Date(x.timestamp)
        x.timestamp = `${monthsName[_ts.getMonth()]}`
        return x
      })
    }
    if (range === "lastWeek" || range === "lastMonth") {
      return data.map((x) => {
        const _ts = new Date(x.timestamp)
        x.timestamp = `${_ts.getDate()} ${monthsName[_ts.getMonth()]}`
        return x
      })
    }
    if (range === "lastDay") {
      return data.map((x) => {
        const _ts = moment(x.timestamp)
        x.timestamp = _ts.format('HH:mm');
        return x
      })
    }
    return data
  }

  async componentDidMount () {
    const curTimeRange = timeranges[this.state.curRange].range

    let newDataResponse =  {}
    try {
      newDataResponse = await this.getNewData();
    } catch (e) {
      console.log(e)
    }

    let historicalDataResponse = []
    try {
      historicalDataResponse = await this.getHistoricalData(curTimeRange)
    } catch (e) {
      console.log(e)
    }

    this.setState({ newData: newDataResponse, historicalData: historicalDataResponse })

    setInterval(async () => {
      try {
        const periodicResult = await this.getNewData()
        // const periodicResult = testData()
        this.setState({ newData: periodicResult })
      } catch (e) {}
    }, 15000)
  }


  changeSeason() {
    if (this.state.testSeason == 'winter') {
      this.setState({testSeason: 'summer'})
    } else {
      this.setState({testSeason: 'winter'})
    }
  }

  render () {

    const CustomPlotData = this.state.newData
    CustomPlotData.daynight = isDayOrNight(new Date(), CustomPlotData.sunrise, CustomPlotData.sunset)
    CustomPlotData.season = CustomPlotData.season === "0" ? "summer" : "winter"
    // CustomPlotData.season = this.state.testSeason
    return (
      <div style={{ minHeight: "100%" }}>
        <CustomPlot data={CustomPlotData} />
        {/*<button onClick={this.changeSeason.bind(this)}>campia  stagione</button>*/}
        <div style={{ margin: 5 }}>
          <small>Ultimo aggiornamento: {moment(CustomPlotData.ts).format('HH:mm DD/MM')}</small>

          <h3 style={{ marginTop: '20px' }}>Dati Storici</h3>
          <form>
            <label>
              <span style={{ marginRight: 10 }}>Seleziona Range:</span>
              <select className="select" onChange={this.onSelectChange} value={this.state.curRange}>
              {
                timeranges.map((x, i) => <option key={`key_${i}`} value={i}>{x.name}</option>)
              }
              </select>
            </label>
          </form>
        </div>
        <div style={{ height: "50%", marginTop: 30 }}>
          <div className="chart">
            <ResponsiveContainer>
              <LineChart data={this.state.historicalData} margin={{top: 5, right: 30, left: 20, bottom: 5}}>
                <XAxis dataKey="timestamp" />
                <YAxis type="number" domain={['dataMin', 'dataMax']} />
                <CartesianGrid strokeDasharray="3 3" />
                <Tooltip />
                <Legend />
                <Line type="monotone" name={"Temperatura esterna (C)"} dataKey="external-temp" stroke="#264898" activeDot={{r: 8}} />
                {/*<Line type="monotone" name={"Umidità esterna (%)"} dataKey="external-humidity" stroke="#9FBFDE" />*/}
                <Line type="monotone" name={"Temperatura interna (C)"} dataKey="global-temp" stroke="#F38B4A" activeDot={{r: 8}} />
                {/*<Line type="monotone" name={"Umidità Esterna (%)"} dataKey="global-humidity" stroke="#9C2A39" />*/}
              </LineChart>
            </ResponsiveContainer>
          </div>
          <div className="chart">
            <ResponsiveContainer>
              <LineChart width={500} height={350} data={this.state.historicalData} margin={{top: 5, right: 0, left: 0, bottom: 5}}>
                <XAxis dataKey="timestamp" />
                <YAxis />
                <CartesianGrid strokeDasharray="3 3" />
                <Tooltip />
                <Legend />
                <Line type="monotone" name="Potenza solare (kW)" dataKey="PowerPV" stroke="#FF6919" activeDot={{r: 8}} />
                <Line type="monotone" name="Potenza da batteria (kW)" dataKey="PowerBatt" stroke="#258D8E" />
                <Line type="monotone" name="Potenza Consumata (kW)" dataKey="PowerHouse" stroke="#AF3472" />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js